import {moment} from 'helpers';
import {format} from './convert';

export function goalProgress(progress) {
  return {
    goal_id: progress.goalId,
    id: progress.serverId,
    timestamp: moment(progress.lastDayOfTheWeek, format).unix(),
    value: parseFloat(progress.weeklyProgress),
  }
}
